<ng-template #showPrivatePlans let-offcanvas>
  <div class="p-5">
    <div class="text-lg font-semibold mb-4">
      Seleccione un plan para agregar:
    </div>
    <div class="" >
        <div style="   overflow-x: hidden; overflow-y: scroll; max-height: 600px;">

      <div *ngFor="let item of privatePlans" >
        <div    class="select-box kb-card mt-3 p-4" (click)="selectPlan(item)" [ngClass]="{ 'opaque-plan': isPlanAdded(item._id) }" *ngIf="!customerPlans_obj[item?._id] && !item?.params?.customer_inactive" >
            <div class="flex">
                <div class="text-primary font-semibold">
                    {{item?.code}}
                </div>
                <div class="ml-auto text-right text-sm">

                    <div class="mr-4">
                        <span *ngIf="item?.params?.init_date">Inicio : {{item?.params?.init_date | date: 'dd/MM/yyyy'}} </span><br>
                            <span *ngIf="item?.params?.end_date"> Fin: {{item?.params?.end_date | date: 'dd/MM/yyyy'}} </span>
                    </div>
                </div>
            </div>
            <div class="mt-1">
                {{item?.name}} / {{item?.version?.internal_code}}
            </div>
            <div class="text-muted-foreground text-sm"  [innerHTML]="item?.description" >
            </div>

            <div class="mt-4">

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Status: {{item?.state}}</span>

                <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Visibilidad: {{item?.visibility}}</span>
                -->

                <span class="kb-badge kb-badge-neutro mr-2 mt-2">Inicial  : {{item?.initial?.status?'Si':'No'}}
                    <span *ngIf="item?.initial?.status"> / {{item?.initial.amount}}<span>{{item?.initial?.type == "percentage"?'%':'USD'}}</span>
                 </span>
                </span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2">Multicompra : {{item?.params?.multiple_invoices?.status? 'Si':'No'}}
                    <span *ngIf="item?.params?.multiple_invoices?.count"> / {{item?.params?.multiple_invoices?.count}}</span>

                </span>
                   <span class="kb-badge kb-badge-neutro mr-2 mt-2">Prioridad  : {{item?.params?.priority}}</span>

                    <br>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.min_amount">Compra minima : {{item?.params?.min_amount}} USD</span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.min_amount_base">Minimo a financiar : {{item?.params?.min_amount_base}} USD</span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.max_amount_base">Maximo a financiar : {{item?.params?.max_amount_base}} USD</span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.current_quota_min">Cupo  minimo: {{item?.params?.current_quota_min}} USD</span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.current_quota_max">Cupo  maximo: {{item?.params?.current_quota_max}} USD</span>

                <div *ngIf="item?.params?.filters?.general?.invoices?.shop || item?.params?.filters?.dinamic_code?.person">
                    <div class="font-semibold mt-4">Filtros </div>

                </div>

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.filters?.general?.invoices?.shop">
                     Tiendas {{item?.params?.filters?.general?.invoices?.shop?.type == 'white_list'?'Permitidas':'Excluidas'}}:
                    <span *ngFor="let shop of item?.params?.filters?.general?.invoices?.shop?.list; let i=index">

                        <span *ngIf="i>0"> ,</span>
                        {{shop}}
                    </span>

                </span>


                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.filters?.dinamic_code?.person">
                    Codigos {{item?.params?.filters?.dinamic_code?.person?.type == 'white_list'?'Permitidos':'Excluidos'}}:
                   <span *ngFor="let shop of item?.params?.filters?.dinamic_code?.person?.list; let i=index">

                       <span *ngIf="i>0"> ,</span>
                       {{shop}}
                   </span>

               </span>






                <div class="font-semibold mt-4">Frecuencias de pago </div>
                <ul>
                  <li *ngFor="let term of item.payment_terms" class="text-sm">
                    {{ term.name }}
                  </li>
                </ul>


                <div *ngIf="item?.params?.invoices_plans">
                <div class="font-semibold mt-4">Solicitudes activas </div>

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.invoices_plans?.invoices?.length > 0">Activas: {{item?.params?.invoices_plans?.invoices?.length}}</span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.invoices_plans?.totalDueBalance">Total: {{item?.params?.invoices_plans?.totalDueBalance}} USD</span>
                <ul class="mt-3">
                  <li *ngFor="let item3 of item?.params?.invoices_plans?.invoices " class="text-sm">
                   <b>{{ item3.identifier }}</b> <span *ngIf="item3?.version_plan"> / {{item3?.version_plan }} </span> : monto financiado <b> {{ item3.dueBalance }} USD </b>
                  </li>
                </ul>

                 </div>

                 <div class="font-semibold mt-4">Paramestros Personales</div>


             <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.multiple_invoices?.count">Cantidad de compras restantes  : {{item?.params?.multiple_invoices?.count  -  item?.params?.invoices_plans?.invoices?.length }}</span>

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.max_amount_base_total">Monto disponible del plan : {{item?.params?.max_amount_base_total}} USD</span>
                <span class="kb-badge kb-badge-exito mr-2 mt-2" *ngIf="item?.params?.max_amount_base_total_quota">Cupo disponible : {{item?.params?.max_amount_base_total_quota}} USD</span>


            </div>



        </div>
      </div>
    </div>
</div>

  </div>
</ng-template>


<ng-template #newCode let-offcanvas>
  <app-new-code-people></app-new-code-people>
</ng-template>

<!-- New Modern Header Section -->
<!-- `kb-page` en vez de `min-h-screen` + un `max-w-6xl` propio: así esta
     pantalla mide lo mismo que el listado y el detalle de planes. Antes cada
     pantalla elegía su propio ancho y al pasar de una a otra el contenido
     saltaba de lugar. -->
<div class="kb-page">
    <div>

        <!-- Customer Profile Section -->
        <div *ngIf="!loading && person?.person" class="mb-6">
            <div class="kb-card p-6">
                <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                     class="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity">
                    <div class="flex-shrink-0">
                        <img
                            *ngIf="person?.person?.file_selfie"
                            class="w-16 h-16 rounded-full object-cover border-2 border-primary"
                            [src]="sanitize(person?.person?.file_selfie?.url)"
                            alt="Avatar del cliente"
                        />
                        <img
                            *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-primary"
                            [src]="sanitize('../assets/public/images/avatar.png')"
                            alt="Avatar del cliente"
                        />
                        <img
                            *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-primary"
                            [src]="sanitize('../assets/public/images/avatara-female.png')"
                            alt="Avatar del cliente"
                        />
                    </div>
                    <div class="flex-1">
                        <h2 class="text-xl font-bold text-foreground capitalize hover:text-primary transition-colors">
                            {{person?.person?.name}} {{person?.person?.lastName}}
                        </h2>
                        <div class="flex flex-wrap gap-4 mt-1 text-sm text-muted-foreground">
                            <div class="flex items-center gap-1">
                                <i class="fas fa-id-card text-primary"></i>
                                <span>{{getIdentity(person)}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="fas fa-phone text-primary"></i>
                                <span>{{getContact(person)}}</span>
                            </div>
                            <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                                <i class="fas fa-envelope text-primary"></i>
                                <span>{{getEmailContact(person)}}</span>
                            </div>
                        </div>
                        <!-- Badges de códigos dinámicos -->
                        <div class="mt-3" *ngIf="personDynamicCodes && personDynamicCodes.length > 0">
                            <span
                                *ngFor="let code of personDynamicCodes"
                                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-muted text-foreground mr-2 mb-1">
                                {{code}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading || plans_loading" class="text-center py-12">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4"></div>
            <p class="text-muted-foreground">Cargando información...</p>
        </div>

        <!-- Action Buttons -->
        <div data-rbac-permiso="planes.etiquetas.read planes.etiquetas.assign planes.etiquetas.delete" *ngIf="!loading && !plans_loading && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['planes.etiquetas.read', 'planes.etiquetas.assign', 'planes.etiquetas.delete']))" class="flex justify-between items-center mb-6">
            <button class="inline-flex items-center px-4 py-2 text-sm font-medium text-primary-foreground bg-primary border border-transparent rounded-lg hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring transition-colors duration-200"
                    (click)="pocisionBottom(newCode)">
                <i class="fas fa-plus mr-2"></i>
                Agregar etiqueta
            </button>
        </div>

        <!-- Plans Section -->
        <div data-rbac-permiso="planes.consultar_planes.read" class="space-y-4" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['planes.consultar_planes.read'])">

    <ng-container   *ngFor="let item of privatePlans">

            <div class="mt-3 pt-4 pb-4 my-3 p-3 bg-card rounded shadow-sm" *ngIf="customerPlans_obj[item?._id] ||  item?.params?.customer_inactive">
                <div [ngClass]="{'relative': item?.params?.customer_inactive}" >

            <div  *ngIf="item?.params?.customer_inactive" class="overlay"></div>

                <div class="search-results">
                            <div class="ml-auto text-right text-sm">
                <div class="cursor-pointer float-right"  *ngIf="!item?.params?.customer_inactive">
                    <i
                    class="far fa-trash-alt text-destructive"
                    style="font-size: 18px; cursor: pointer !important;"
                    (click)="removePlan(item)"
                    ></i>
                </div>
                </div>

                <div >
                    <div class="flex">
                        <div class="text-primary font-semibold">
                            {{item?.code}} <span class="text-destructive font-normal" *ngIf="item?.params?.customer_inactive"> (No disponible)</span>
                        </div>
                        <div class="ml-auto text-right text-sm">

                            <div class="mr-4">
                                <span *ngIf="item?.params?.init_date">Inicio : {{item?.params?.init_date | date: 'dd/MM/yyyy'}} </span><br>
                            <span *ngIf="item?.params?.end_date"> Fin: {{item?.params?.end_date | date: 'dd/MM/yyyy'}} </span>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1">
                        {{item?.name}} / {{item?.version?.internal_code}}
                    </div>
                    <div class="text-muted-foreground text-sm"  [innerHTML]="item?.description" >
                    </div>

                    <div class="mt-4">

                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Status: {{item?.state}}</span>

                        <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Visibilidad: {{item?.visibility}}</span>
                        -->

                        <span class="kb-badge kb-badge-neutro mr-2 mt-2">Inicial  : {{item?.initial?.status?'Si':'No'}}
                            <span *ngIf="item?.initial?.status"> / {{item?.initial.amount}}<span>{{item?.initial?.type == "percentage"?'%':'USD'}}</span>
                         </span>
                        </span>

                        <span class="kb-badge kb-badge-neutro mr-2 mt-2">Multicompra : {{item?.params?.multiple_invoices?.status? 'Si':'No'}}
                            <span *ngIf="item?.params?.multiple_invoices?.count"> / {{item?.params?.multiple_invoices?.count}}</span>

                        </span>                        <span class="kb-badge kb-badge-neutro mr-2 mt-2">Prioridad  : {{item?.params?.priority}}</span>

                            <br>
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.min_amount">Compra minima : {{item?.params?.min_amount}} USD</span>
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.min_amount_base">Minimo a financiar : {{item?.params?.min_amount_base}} USD</span>
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.max_amount_base">Maximo a financiar : {{item?.params?.max_amount_base}} USD</span>
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.current_quota_min">Cupo  minimo: {{item?.params?.current_quota_min}} USD</span>
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.current_quota_max">Cupo  maximo: {{item?.params?.current_quota_max}} USD</span>

                        <div *ngIf="item?.params?.filters?.general?.invoices?.shop || item?.params?.filters?.dinamic_code?.person">
                            <div class="font-semibold mt-4">Filtros </div>

                        </div>

                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.filters?.general?.invoices?.shop">
                             Tiendas {{item?.params?.filters?.general?.invoices?.shop?.type == 'white_list'?'Permitidas':'Excluidas'}}:
                            <span *ngFor="let shop of item?.params?.filters?.general?.invoices?.shop?.list; let i=index">

                                <span *ngIf="i>0"> ,</span>
                                {{shop}}
                            </span>

                        </span>


                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.filters?.dinamic_code?.person">
                            Codigos {{item?.params?.filters?.dinamic_code?.person?.type == 'white_list'?'Permitidos':'Excluidos'}}:
                           <span *ngFor="let shop of item?.params?.filters?.dinamic_code?.person?.list; let i=index">

                               <span *ngIf="i>0"> ,</span>
                               {{shop}}
                           </span>

                       </span>






                        <div class="font-semibold mt-4">Frecuencias de pago </div>
                        <ul>
                          <li *ngFor="let term of item.payment_terms" class="text-sm">
                            {{ term.name }}
                          </li>
                        </ul>



                        <div *ngIf="item?.params?.invoices_plans">
                        <div class="font-semibold mt-4">Solicitudes activas </div>

                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.invoices_plans?.invoices?.length > 0">Activas: {{item?.params?.invoices_plans?.invoices?.length}}</span>
                        <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.invoices_plans?.totalDueBalance">Total: {{item?.params?.invoices_plans?.totalDueBalance}} USD</span>
                        <ul class="mt-3">
                          <li *ngFor="let item3 of item?.params?.invoices_plans?.invoices " class="text-sm">
                           <b>{{ item3.identifier }}</b> <span *ngIf="item3?.version_plan"> / {{item3?.version_plan }} </span> : monto financiado <b> {{ item3.dueBalance }} USD </b>
                          </li>
                        </ul>

                         </div>

                         <div class="font-semibold mt-4">Paramestros Personales</div>

             <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.multiple_invoices?.count">Cantidad de compras restantes  : {{item?.params?.multiple_invoices?.count  -  item?.params?.invoices_plans?.invoices?.length }}</span>


                       <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.multiple_invoices?.status">Cantidad de compras restantes  : {{item?.params?.multiple_invoices?.count  -  item?.params?.invoices_plans?.invoices?.length }}</span>

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Monto disponible del plan : {{item?.params?.max_amount_base_total}} USD</span>
                <span class="kb-badge kb-badge-exito mr-2 mt-2" >Cupo disponible : {{item?.params?.max_amount_base_total_quota}} USD</span>

                    </div>

                </div>
            </div>


                <div>

                </div>

                </div>

        </div>
    </ng-container>

    <!--
           <div *ngIf="!isCustomerPlans_obj" class="kb-card p-6">
        <p>Este cliente no tiene planes privados asociados.</p>
    </div>

    -->

<div *ngIf="!loading && !plans_loading " class="w-full mt-5 mb-3">
    <!-- <div class="input_group">
        <div class="form-floating">
            <div class="text-lg font-semibold text-muted">
                Públicos
            </div>
        </div>
    </div>-->

    <div class="kb-card p-6" *ngIf="publicPlans?.length > 0">
        <ng-container *ngFor="let item of publicPlans">

            <div [ngClass]="{'relative': item?.params?.customer_inactive}" >
                <div  *ngIf="item?.params?.customer_inactive" class="overlay"></div>

                <div class="flex">
                    <div class="text-primary font-semibold">
                        {{item?.code}} <span class="text-destructive font-normal" *ngIf="item?.params?.customer_inactive"> (No disponible)</span>
                    </div>
                    <div class="ml-auto text-right text-sm">

                        <div class="mr-4">
                            <span *ngIf="item?.params?.init_date">Inicio : {{item?.params?.init_date | date: 'dd/MM/yyyy'}} </span><br>
                            <span *ngIf="item?.params?.end_date"> Fin: {{item?.params?.end_date | date: 'dd/MM/yyyy'}} </span>
                        </div>
                    </div>
                </div>
                <div class="mt-1">
                    {{item?.name}} / {{item?.version?.internal_code}}
                </div>
                <div class="text-muted-foreground text-sm"  [innerHTML]="item?.description" >
                </div>

                <div class="mt-4">

                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Status: {{item?.state}}</span>
                    <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Visibilidad: {{item?.visibility}}</span>
                    -->

                    <span class="kb-badge kb-badge-neutro mr-2 mt-2">Inicial  : {{item?.initial?.status?'Si':'No'}}
                        <span *ngIf="item?.initial?.status"> / {{item?.initial.amount}}<span>{{item?.initial?.type == "percentage"?'%':'USD'}}</span>
                     </span>
                    </span>

                    <span class="kb-badge kb-badge-neutro mr-2 mt-2">Multicompra : {{item?.params?.multiple_invoices?.status? 'Si':'No'}}
                        <span *ngIf="item?.params?.multiple_invoices?.count"> / {{item?.params?.multiple_invoices?.count}}</span>

                    </span>
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2">Prioridad  : {{item?.params?.priority}}</span>

                        <br>
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.min_amount">Compra minima : {{item?.params?.min_amount}} USD</span>
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.min_amount_base">Minimo a financiar : {{item?.params?.min_amount_base}} USD</span>
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.max_amount_base">Maximo a financiar : {{item?.params?.max_amount_base}} USD</span>
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.current_quota_min">Cupo  minimo: {{item?.params?.current_quota_min}} USD</span>
                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.current_quota_max">Cupo  maximo: {{item?.params?.current_quota_max}} USD</span>

                    <div *ngIf="item?.params?.filters?.general?.invoices?.shop || item?.params?.filters?.dinamic_code?.person">
                        <div class="font-semibold mt-4">Filtros </div>

                    </div>

                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.filters?.general?.invoices?.shop">
                         Tiendas {{item?.params?.filters?.general?.invoices?.shop?.type == 'white_list'?'Permitidas':'Excluidas'}}:
                        <span *ngFor="let shop of item?.params?.filters?.general?.invoices?.shop?.list; let i=index">

                            <span *ngIf="i>0"> ,</span>
                            {{shop}}
                        </span>

                    </span>


                    <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.filters?.dinamic_code?.person">
                        Codigos {{item?.params?.filters?.dinamic_code?.person?.type == 'white_list'?'Permitidos':'Excluidos'}}:
                       <span *ngFor="let shop of item?.params?.filters?.dinamic_code?.person?.list; let i=index">

                           <span *ngIf="i>0"> ,</span>
                           {{shop}}
                       </span>

                   </span>

                    <div class="font-semibold mt-4">Frecuencias de pago </div>
                    <ul>
                      <li *ngFor="let term of item.payment_terms" class="text-sm">
                        {{ term.name }}
                      </li>
                    </ul>

                </div>



                <div *ngIf="item?.params?.invoices_plans">
                <div class="font-semibold mt-4">Solicitudes activas </div>

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.invoices_plans?.invoices?.length > 0">Activas: {{item?.params?.invoices_plans?.invoices?.length}}</span>
                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.invoices_plans?.totalDueBalance">Total: {{item?.params?.invoices_plans?.totalDueBalance}} USD</span>
                <ul class="mt-3">
                  <li *ngFor="let item3 of item?.params?.invoices_plans?.invoices " class="text-sm">
                   <b>{{ item3.identifier }}</b> <span *ngIf="item3?.version_plan"> / {{item3?.version_plan }} </span> : monto financiado <b> {{ item3.dueBalance }} USD </b>
                  </li>
                </ul>

                 </div>

                 <div class="font-semibold mt-4">Paramestros Personales</div>


                <span class="kb-badge kb-badge-neutro mr-2 mt-2" *ngIf="item?.params?.multiple_invoices?.count">

                    <span *ngIf="item?.params?.multiple_invoices?.status">Cantidad de compras restantes  : {{item?.params?.multiple_invoices?.count  -  item?.params?.invoices_plans?.invoices?.length }}</span>
                </span>

                <span class="kb-badge kb-badge-neutro mr-2 mt-2" >Monto disponible del plan : {{item?.params?.max_amount_base_total}} USD</span>
                <span class="kb-badge kb-badge-exito mr-2 mt-2" >Cupo disponible : {{item?.params?.max_amount_base_total_quota}} USD</span>


               </div>
            <div class="border-bottom pb-4 mb-4"></div>
        </ng-container>

    </div>

    <div *ngIf="publicPlans?.length < 1 && !plans_loading" class="kb-card p-6">
        <p>No se encontraron planes publicos disponibles</p>
    </div>

        </div>
    </div>
</div>
<!-- 📍 Este cierre FALTABA desde antes: el contenedor de la página nunca se
     cerraba y Angular lo cerraba solo al llegar al final del archivo. Funciona
     igual, pero deja el archivo bien formado. -->
</div>
